module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_10-1df047da46204929825acf1c2b40f61f.svg";